var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-pikaday", {
    ref: "pikaday",
    attrs: { placeholder: "TT.MM.YYYY", options: _vm.pikadayOptions },
    model: {
      value: _vm.date,
      callback: function ($$v) {
        _vm.date = $$v
      },
      expression: "date",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }